// Permisos especiales (fuera de la matriz por modulo). Hoy solo existe
// `puede_solicitar_cambios`: el backend lo devuelve junto al objeto de permisos
// (GET /users/me/permisos y GET /users/id/{id}/permisos) y lo recibe como campo
// aparte en PUT /users/id/{id}/permisos.
// `es_administracion` solo lo informa GET /users/id/{id}/permisos (no se guarda).

export const PERMISO_SOLICITAR_CAMBIOS = "puede_solicitar_cambios";

const CLAVES_ESPECIALES = [PERMISO_SOLICITAR_CAMBIOS, "es_administracion"];

// Copia del objeto de permisos sin las llaves especiales (solo modulos).
export const sinPermisosEspeciales = (permisos) =>
  Object.fromEntries(Object.entries(permisos || {}).filter(([k]) => !CLAVES_ESPECIALES.includes(k)));
